var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex",staticStyle:{"flex-direction":"column"}},[_vm._m(0),_c('div',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"mt-2",staticStyle:{"flex":"1"},attrs:{"id":this.id},on:{"resize":_vm.update}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"62px"}},[_c('h4',[_vm._v("Статистические показатели ставок капитализации по объектам-аналогам")])])
}]

export { render, staticRenderFns }